/**
 * Web stub for `expo-notifications`. Native/Expo push is unavailable in the
 * browser, so every operation reports "permission not granted": the app's
 * best-effort `registerForPushNotifications()` sees `granted = false` and
 * silently skips token registration — graceful degradation with no crash.
 *
 * If/when we add real browser push, replace this stub with a Web Push
 * (Service Worker + VAPID) implementation that mirrors the same surface.
 */

type PermissionResponse = {
  granted: boolean;
  canAskAgain: boolean;
  status: 'granted' | 'denied' | 'undetermined';
};

const DENIED: PermissionResponse = {
  granted: false,
  canAskAgain: false,
  status: 'undetermined',
};

export const setNotificationHandler = (_handler: unknown): void => undefined;

export const getPermissionsAsync = async (): Promise<PermissionResponse> => DENIED;

export const requestPermissionsAsync = async (): Promise<PermissionResponse> => DENIED;

export const getExpoPushTokenAsync = async (
  _opts?: { projectId?: string }
): Promise<{ data: string }> => ({ data: '' });

export const getLastNotificationResponseAsync = async (): Promise<null> => null;

export const addNotificationResponseReceivedListener = (
  _listener: (response: unknown) => void
): { remove: () => void } => ({ remove: () => undefined });

export const removeNotificationSubscription = (_subscription: {
  remove: () => void;
}): void => undefined;
